import { z } from 'zod';

const grammarCheckpointFamilySchemaDefinition = z.object({
  family: z.string(),
  correct: z.number().int().min(0),
  total: z.number().int().min(0),
});

export const grammarCheckpointFamilySchema: typeof grammarCheckpointFamilySchemaDefinition =
  grammarCheckpointFamilySchemaDefinition;

export type IGrammarCheckpointFamily = z.infer<typeof grammarCheckpointFamilySchema>;
